<template>
  <div>
    <b-modal v-model="openRequestModal" :title="title" size="lg" @ok.prevent="attemptRequestSubmit = true"
      @cancel="editingAffiliateWorkRequest = false">
      <affiliate-work-request-form v-model="attemptRequestSubmit"
        :affiliateWorkRequest="editingAffiliateWorkRequest ? selectedRequest : null"
        :totalPercent="affiliateWorkPercent" :usedPercent="totalAffiliateWorkPercent"
        v-on:complete="processAffiliateWorkRequest" v-if="openRequestModal"></affiliate-work-request-form>
    </b-modal>

    <b-modal v-model="confirmDeletion" title="Confirm Delete" v-if="selectedRequest"
      @ok="removeAffiliateWorkRequest(selectedRequest)" @cancel="clearAffiliateWorkRequest()">
      Are you sure you want to delete this affiliate work request?
      <div>
        {{ selectedRequest.notes }}
      </div>
    </b-modal>

    <table-widget :items="requests" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
        <b-button v-if="editable" @click="openRequestAdd()" class="ml-2" variant="primary"><font-awesome-icon
            icon="plus" />Add Affiliate Work
          Request</b-button>
      </template>

      <template slot="content">
        <!-- <b-alert :show="editable"><font-awesome-icon icon="exclamation-circle" /> Affiliate work
          requests are not saved until you click the submit button
          below.</b-alert> -->
        <b-table striped :items="selectedRequests" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no requests that match your search criteria.">
          <template v-slot:cell(createdDate)="data">
            <template v-if="data.item.createdDate">
              {{ data.item.createdDate | formatDateTime }}
            </template>

            <template v-else> Not Submitted </template>
          </template>

          <template v-slot:cell(fileName)="data">
            <template v-if="data.item.fileId">
              <a target="_blank" :href="getFileHref(data.item.fileId)"><font-awesome-icon icon="download" />
                {{ data.item.fileName }}</a>
            </template>

            <template v-else-if="data.item.fileName">
              {{ data.item.fileName }}
            </template>

            <template v-else> No File </template>
          </template>
          <template v-slot:cell(percent)="data">
            {{ data.item.percent || 0 }}
          </template>

          <template v-slot:cell(status)="data">
            {{ data.item.currentStatus.name }}
          </template>

          <template v-slot:cell(controls)="data">
            <div class="text-right" v-if="(data.item.currentStatus.name == 'Submitted' ||
              data.item.currentStatus.name == 'Not Submitted' || data.item.currentStatus.name == 'Resubmit') &&
              editable
            ">
              <!-- <font-awesome-icon icon="pencil-alt" class="edit-icon mx-1"
                @click="openRequestEdit(data.item)"></font-awesome-icon> -->
              <font-awesome-icon icon="times" class="remove-icon mx-1"
                @click="confirmRemoveRequest(data.item)"></font-awesome-icon>
            </div>
          </template>
          <!-- <template v-slot:custom-foot="data">
            <b-tr>
              <b-td>Total:</b-td>
              <b-td
                >{{ totalAffiliateWorkPercent }}% used out of {{ affiliateWorkPercent }}% total
                affiliate work percent.</b-td
              >
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
          </template> -->
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget"
import AffiliateWorkRequestForm from "./affiliate-work-request-form.vue"
export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "status", sortable: true, label: "Status" },
        { key: "percent", sortable: true, label: "Percent" },
        { key: "notes", label: "Notes" },
        { key: "fileName", label: "File" },
        { key: "createdDate", sortable: true, label: "Date" },
        { key: "controls", label: "" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedRequests: [],
      openRequestModal: false,
      editingAffiliateWorkRequest: false,
      selectedRequest: null,
      attemptRequestSubmit: false,
      confirmDeletion: null
    }
  },

  props: {
    requests: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    affiliateWorkPercent: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return "New Affiliate Work Request"
      }
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    }
  },

  components: {
    TableWidget,
    AffiliateWorkRequestForm
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    getFileHref: function (fileId) {
      // console.log("File ID:");
      // console.log(fileId);

      return process.env.VUE_APP_BASE_URI + "/api/files/" + fileId
    },

    openRequestAdd: function () {
      this.openRequestModal = true
    },

    processAffiliateWorkRequest: function (affiliateWorkRequest) {
      this.attemptRequestSubmit = false
      if (affiliateWorkRequest) {
        if (this.editingAffiliateWorkRequest) {
          this.$emit("edited", affiliateWorkRequest)
        } else {
          this.$emit("added", affiliateWorkRequest)
        }
        this.openRequestModal = false
      }
      this.editingAffiliateWorkRequest = false
    },

    openRequestEdit: function (request) {
      this.selectedRequest = request
      this.editingAffiliateWorkRequest = true
      this.openRequestModal = true
    },

    confirmRemoveRequest(request) {
      this.selectedRequest = request
      this.confirmDeletion = true
    },
    removeAffiliateWorkRequest(request) {
      //this.buyouts.splice(index, 1);
      this.$emit("removed", request)
    },
    clearAffiliateWorkRequest() {
      this.selectedRequest = null
    }
  },

  computed: {
    totalAffiliateWorkPercent: function () {
      if (!this.requests) return 0
      return _.sumBy(this.requests, request => {
        if (
          request.currentStatus &&
          (request.currentStatus.name == "Submitted" ||
            request.currentStatus.name == "Approved")
        ) {
          return parseFloat(request.affiliateWorkPercent)
        }
        return 0
      })
    }
  },

  watch: {
    requests: function () {
      if (this.requests.length) {
        this.selectedRequests = this.requests
        this.totalRows = this.requests.length
      }
    }
  },

  created() {
    if (this.requests.length) {
      this.selectedRequests = this.requests
      this.totalRows = this.requests.length
    }
  }
}
</script>

<style scoped></style>
